module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1027-2dfb7fae72d18b71676a2f8580e0f478.png";